import { ReactNode } from 'react';
import { css } from '@bts-web/utils-style-engine';
import {
  BelowInputInfoTable,
  BelowInputInfoTableProps,
  Collapsible,
} from '../../../common';
import { RegularGuaranteeCheckmark } from '../../../common/svgIcons';

export type FeesListTranslations = {
  priceGuarantee: string;
  feesIncluded: string;
  offerFeesDescription: string;
};

type FeesListLeftSlot =
  | { showPriceGuarantee: string; headerLeftSlotContent?: never }
  | { headerLeftSlotContent: ReactNode; showPriceGuarantee?: never }
  | { showPriceGuarantee?: never; headerLeftSlotContent?: never };

type FeesListProps = FeesListLeftSlot & {
  headerRightSlotContent: string;
  offerFeesDescription?: string;
  items: BelowInputInfoTableProps['items'];
};

export const FeesList = ({
  headerRightSlotContent,
  offerFeesDescription,
  items,
  showPriceGuarantee,
  headerLeftSlotContent,
}: FeesListProps) => {
  let leftSlot: ReactNode = null;

  if (showPriceGuarantee !== undefined) {
    leftSlot = (
      <span
        className={css({
          display: 'flex',
          gap: 'extra_small_3',
          alignItems: 'center',
        })}
      >
        {showPriceGuarantee}
        <RegularGuaranteeCheckmark
          data-testid="guarantee-icon"
          data-element="guarantee-icon"
          size={16}
          color="positive.fill_primary"
        />
      </span>
    );
  } else if (headerLeftSlotContent) {
    leftSlot = headerLeftSlotContent;
  }

  return (
    <Collapsible
      header={{
        RightContentIndicatorSlot: headerRightSlotContent,
        LeftContentIndicatorSlot: leftSlot,
      }}
    >
      <div
        data-testid="transaction-fees"
        className={css({
          display: 'flex',
          flexDirection: 'column',
          pb: 'medium',
          gap: 'medium',
          borderBottom: '1px solid',
          borderBottomColor: 'neutrals.divider',
        })}
      >
        <BelowInputInfoTable items={items} />

        {offerFeesDescription && (
          <p
            className={css({
              color: 'neutrals.text_secondary',
              fontSize: 'caption.medium_medium',
              fontWeight: 'caption.medium_medium',
              letterSpacing: 'caption.medium_medium',
              lineHeight: 'caption_medium',
            })}
          >
            {offerFeesDescription}
          </p>
        )}
      </div>
    </Collapsible>
  );
};
